import React from 'react';

const CloseIconChecker= ({ size, color = '#fff', onClick }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    version='1.0'
    width={size}
    height={size}
    viewBox='0 0 512.000000 512.000000'
    preserveAspectRatio='xMidYMid meet'
    onClick={onClick}
  >
    <g
      transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
      fill={color}
      stroke='none'
    >
      <path d='M1121 4148 c-31 -7 -57 -23 -91 -57 -62 -62 -79 -127 -54 -211 15 -53 34 -73 647 -687 l632 -633 -632 -632 c-613 -615 -632 -635 -647 -688 -49 -166 98 -313 264 -264 53 15 75 36 688 647 l632 632 633 -632 c612 -611 634 -632 687 -647 166 -49 313 98 264 264 -15 53 -36 75 -647 687 l-632 633 632 633 c611 612 632 634 647 687 49 166 -98 313 -264 264 -53 -15 -73 -34 -687 -647 l-633 -632 -632 632 c-612 610 -635 632 -687 647 -61 18 -59 18 -120 4z' />
    </g>
  </svg>
);

export default CloseIconChecker;
